import React, { Component } from 'react';

//React-PDF dependencies
import { View, Document, Image } from "@react-pdf/renderer";

class PdfIcon extends Component {

  render() {
    return(
      <View style={this.props.style}>
        <Image src={this.props.src} style={this.props.style.icon}/>
      </View>
    );
  }
}

export default PdfIcon;


// WEBPACK FOOTER //
// src/components/innerComponents/pdfComponents/PdfIcon.js